export default "__VITE_ASSET__DXs8KMqO__"